import PageHero from "@/components/shared/PageHero";
import ServicesAndMarketing from "@/components/sections/ServicesAndMarketing";
import CTASection from "@/components/sections/CTASection";
import { ASSETS, BRAND } from "@/lib/brand";

export default function ServicesPage() {
  return (
    <div data-testid="page-services">
      <PageHero
        eyebrow="Services"
        title={<>Consulting & <span className="italic text-bronze">marketing,</span> end-to-end.</>}
        sub="Two complementary offerings — strategic property consulting and high-impact marketing — designed to grow your portfolio and showcase your home."
        image={ASSETS.lifestyle.handshake}
        ctas={[
          { label: "Start Your Journey", href: BRAND.whatsapp, variant: "primary" },
          { label: "About Me", to: "/why-me/about-me", variant: "secondary" },
        ]}
        meta={[
          { label: "Consulting", value: "6 pillars" },
          { label: "Marketing", value: "6 channels" },
          { label: "Approach", value: "1:1 bespoke" },
        ]}
      />
      <ServicesAndMarketing />
      <CTASection />
    </div>
  );
}
